"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.toast = exports.ToastType = void 0;
var react_1 = require("@emotion/react");
var colors_1 = require("./colors");
// TODO:(용재) 추후 원인 파악
exports.ToastType = {
    success: 'success',
    error: 'error',
};
exports.toast = {
    type: (_a = {},
        _a[exports.ToastType.success] = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n      border: 0.1rem solid ", ";\n    "], ["\n      background-color: ", ";\n      border: 0.1rem solid ", ";\n    "])), colors_1.colors.green10, colors_1.colors.green40),
        _a[exports.ToastType.error] = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: ", ";\n      border: 0.1rem solid ", ";\n    "], ["\n      background-color: ", ";\n      border: 0.1rem solid ", ";\n    "])), colors_1.colors.red10, colors_1.colors.red40),
        _a),
};
var templateObject_1, templateObject_2;
